<template>
  <div class="d-flex flex-column gap-sm">
  <div class="details__controls">
    <a @click.prevent="showEditModal({})" href="#" class="form__btn form__btn--reset btn btn--2 ">
      <span class="text-capitalize-first">{{ $t('button.create') }}</span>
    </a>
  </div>

  <LoaderContent ref="loader">
    <div style="overflow: auto">
      <table class="table table__flex" style="position: relative">
        <thead>
        <tr>
          <th class="ps" style="text-align: left"><span class="text-capitalize-first">{{ $t('labels.name')}}</span></th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="user in response.items" :key="user.id" class="">
          <td class="">
            <div class="d-flex gap-sm align-items-center">
              <div>
                <SvgIcon class="icon icon__attention" v-if="user.isBlocked" v-b-tooltip.hover :title="helper.trans('labels.user_blocked')" icon="cancel"></SvgIcon>
              </div>
              <div class="d-flex flex-column">
                <span>{{user.name}}</span>
                <small>{{user.email}}</small>
              </div>
            </div>
          </td>
          <td>
            <div class="detail__controls" style="">
              <button type="button" @click="showEditModal(user)" class="btn btn-sm">
                <span class="text-capitalize-first">{{helper.trans('button.edit')}}</span>
              </button>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <b-pagination
      v-if="response.totalCount > response.items.length"
      v-model="page"
      :total-rows="response.totalCount"
      :per-page="response.limit"
      :limit="20"
      @update:modelValue="loadList()"
      prev-text="Back"
      next-text="Next"
      align="start"
      first-number
      hide-goto-end-buttons
      hide-ellipsis
    ></b-pagination>
  </LoaderContent>
  </div>
  <TraderOperatorFormPopup @updated="loadList" ref="traderOperatorFormPopup"></TraderOperatorFormPopup>
</template>
<script lang="ts">
import {computed, defineComponent, onMounted, onUnmounted, reactive, ref, toRefs} from 'vue'
import {$t, helper} from "@/service/CommonHelper";

import TraderDashboard from "@/apps/public/components/dashboard/TraderDashboard.vue";
import {useStore} from "vuex";
import LoaderContent from "@/apps/public/components/LoaderContent.vue";
import {dateHelper} from "@/service/DateHelper";
import {api} from '@/service/APIClient';
import {BPagination} from "bootstrap-vue-3";
import SvgIcon from "@/apps/public/components/SvgIcon.vue";
import CopyButton from "@/apps/public/components/CopyButton.vue";
import {numberFormatter} from "@/service/NumberFormatter";
import PaymentTime from "@/apps/public/components/PaymentTime.vue";
import PayMethodIcon from "@/components/PayMethodIcon.vue";
import LoaderButton from "@/apps/public/components/LoaderButton.vue";
import Multiselect from "vue-multiselect";
import {DatePicker} from "v-calendar";
import DevicesMultiselect from "@/components/DevicesMultiselect.vue";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import TraderOperatorDTO from "@/models/TraderOperatorDTO";
import TraderOperatorFormPopup from "@/apps/public/components/TraderOperatorFormPopup.vue";

export default defineComponent({
  methods: {$t},
  components: {
    DevicesMultiselect,
    DatePicker,
    LoaderButton,
    PayMethodIcon,
    PaymentTime,
    CopyButton,
    SvgIcon,
    BPagination,
    LoaderContent,
    TraderDashboard,
    Multiselect,
    TraderOperatorFormPopup
  },
  setup() {
    const store = useStore()
    const loader = ref<InstanceType<typeof LoaderContent> | null>(null)
    const traderOperatorFormPopup = ref<InstanceType<typeof TraderOperatorFormPopup> | null>(null)

    const state = reactive({
      page: 1,
      response: {
        limit: 20,
        offset: 0,
        totalCount: 0,
        items: []
      } as PaginatedResponseDTO<TraderOperatorDTO>
    });

    const loadList = async () => {
      loader.value?.show()
      state.response.offset = state.response.limit * (state.page - 1)
      state.response = await api.call.traderOperators.list(state.response)
      loader.value?.hide()
    }

    const showEditModal = async (dto: TraderOperatorDTO) => {
      traderOperatorFormPopup.value?.show(dto)
    }

    const save = () => {

    }

    onMounted(() => {
      loadList()
    });

    return {
      ...toRefs(state),
      loader,
      dateHelper,
      numberFormatter,
      helper,
      showEditModal,
      save,
      loadList,
      traderOperatorFormPopup,
      isOperator: computed(() => store.getters.isOperator),
      isAdmin: computed(() => store.getters.isAdmin),
      isTrader: computed(() => store.getters.isTrader),
    }
  }
})
</script>
